import { Component, OnInit, ViewChild } from '@angular/core';
import { MatListOption } from '@angular/material/list';
import { TranslateService } from '@ngx-translate/core';
import { BaseComponent } from 'src/app/moov-common/base/base.component';
import { AccountTypeEnum, ClaroRoles, ResellerTokesStatusData, ResellerTypeEnum, UserCreatedOrgData, AccountTypeDescriptions, AccessTokenData, CareerProcessTypeEnum } from 'src/app/moov-common/services/personal-user-data/personal-user-data';
import { AbstractPersonalUserDataService } from 'src/app/moov-common/services/personal-user-data/personal-user-data.abstract.service';
import { Clipboard } from '@angular/cdk/clipboard';
import { EnvConfigService } from 'src/app/moov-common/services/env-config/env-config.service';
import { EnvConfigKeys } from 'src/app/moov-common/services/env-config/env-keys';
import { MatTooltip } from '@angular/material/tooltip';
import { Console } from 'console';
import { UtilsService } from 'src/app/moov-common/services/utils/utils.service';

@Component({
  selector: 'app-reseller-actions',
  templateUrl: './reseller-actions.component.html',
  styleUrls: ['./reseller-actions.component.scss']
})
export class ResellerActionsComponent  extends BaseComponent implements OnInit {
  presentReallocateTokensPart : boolean = false;
  presentAllocatedTokensPart : boolean = false;
  usersReportIdList: string = "";
  orgTokenAllocationAmount : number = 0;
  res_allocatedTokensToGroupList : AccessTokenData[] = [];
  res_allocatedTokensBodiesToGroupList : string[] = [];
  // existingAllocatedTokensToOrgList : AccessTokenData[] = [];
  existingAllocatedTokensToOrgList :{ [key: number]: AccessTokenData[] } = {};
  orgHasAllocatedTokens : boolean = false;
  isWaitingForReport: boolean = false;
  questionsVideoFolder = 'assets/media/questions/';
  resellerTokensStatusData : ResellerTokesStatusData;
  existingTotalAccountTypes: AccountTypeEnum[];
  existingFreeAccountTypes: AccountTypeEnum[];
  existingAllocatedAccountTypes: AccountTypeEnum[];
  orgsData : UserCreatedOrgData[] = [];
  getOrgs_resellerOrgsList: UserCreatedOrgData[] = [];
  isCreatingOrg : boolean = false;
  userCreatedOrgName: string = "";
  userCreatedOrgDescription : string = "";
  selectedOrgId: string = "";
  selectedOrgName : string = "";
  getResellerOrgs_resellerMail : string = "";
  isWaitingForResellerOrgsList : boolean = false;
  resellerActionErrorMessage: string = "";
  resellerOrgActionErrorMessage : string = "";
  isEditingOrg : boolean = false;
  userEditOrgDescription = "";
  userEditOrgName = "";
  resellerActionsTooltipMessage = 'This is a tooltip message!';
  groupedTokens: { [key: number]: AccessTokenData[] } = {};
  careerProcessTypeEnumInstance = CareerProcessTypeEnum;
  selectedAccountTypeForTokenAllocation : AccountTypeEnum = AccountTypeEnum.UNKNOWN;
  selectedCareerProcessTypeForTokenAllocation : CareerProcessTypeEnum = CareerProcessTypeEnum.NONE;
  accountTypesEnumInstance = AccountTypeEnum;
  allocateTokensToOrgErrorMessage : string = "";
  allocateTokenToOrgFailed : boolean = false;

  @ViewChild('tooltip_newTokens') tooltip_newTokens: MatTooltip;
  @ViewChild('tooltip_existingTokens') tooltip_existingTokens: MatTooltip;
  @ViewChild('tooltip_orgId') tooltip_orgId: MatTooltip;

  constructor(private userDataService : AbstractPersonalUserDataService,
              private translate: TranslateService,
              private clipboard: Clipboard,
              private envConfig : EnvConfigService,
              private utils: UtilsService ) {
    super();
   }

  ngOnInit(): void {
    super.ngOnInit();

    this.verifyResellerData();
    this.getResellerTokensStatus();
    this.getUserCreatedOrgs();
  }

  verifyResellerData(): void{
    this.userDataService.getSelfResellerData().subscribe(resellerDetails => {
      if (resellerDetails.resellerType == ResellerTypeEnum.MASTER_RESELLER){
        // this is a master reseller, we need to allow additional actions
        this.presentReallocateTokensPart = true;
      }
      else{
        this.presentReallocateTokensPart = false;
      }
    });
  }

  createOrg(): void{
    this.isCreatingOrg = true;
  }

  submitOrgDetails(): void{
    this.userDataService.createOrgByUser(this.userCreatedOrgName, this.userCreatedOrgDescription).subscribe(res => {
      this.isCreatingOrg = false;
      this.getUserCreatedOrgs();
    });
  }

  getUserCreatedOrgs(): void{
    this.userDataService.getAllUserCreatedOrgs().subscribe(userOrgs => {
      this.orgsData = userOrgs;
    });
  }

  orgListSelectionChanged(selectedOption : MatListOption[]): void{
    // console.log(`orgListSelectionChanged selectedOptions is ${JSON.stringify(selectedOption)}`)
    this.selectedOrgId = selectedOption[0].value;

    let selectedOrgDetails = this.orgsData.find(org => org.id == this.selectedOrgId);
    this.selectedOrgName =  selectedOrgDetails ? selectedOrgDetails.name : "";

    this.res_allocatedTokensToGroupList = [];
    this.getExistingActiveTokensForOrg();
  }

  getExistingActiveTokensForOrg(): void{
    this.existingAllocatedTokensToOrgList = {};
    this.orgHasAllocatedTokens = false;
    this.personalUserDataServiceForBaseClass.getResellerActiveTokensForOrg(this.selectedOrgId).subscribe(allocatedTokens => {
      // this.existingAllocatedTokensToOrgList = allocatedTokens;
      this.existingAllocatedTokensToOrgList = this.groupByAccountType(allocatedTokens);

      // console.log(`RA getExistingActiveTokensForOrg existingAllocatedTokensToOrgList is ${JSON.stringify(this.existingAllocatedTokensToOrgList)}`);

      // DEBUG
      this.orgHasAllocatedTokens = Object.keys(this.existingAllocatedTokensToOrgList).length > 0;
    });
  }

  getResellerUsageReport(){   
    this.isWaitingForReport = true;
    this.userDataService.getResellerUsageReport(this.usersReportIdList).subscribe(data => {
      // console.log('in MM getUserInsightsReport');
      let blob = new Blob([data as BlobPart], {type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'});

      var downloadURL = window.URL.createObjectURL(blob);
      var link = document.createElement('a');
      link.href = downloadURL;
      link.download = "UsersReport.xlsx";
      // this.isReportGenerated = false;
      link.click();
      this.isWaitingForReport = false;
    });
  }

  getResellerTokensStatus(){
    this.userDataService.getResellerTokensStatus().subscribe(tokensData => {
      let convertedTokensData : ResellerTokesStatusData = {allocatedTokens:{},freeTokens:{},totalActiveTokens:{}};


      convertedTokensData.allocatedTokens = this.utils.convertKeysToInt(tokensData.allocatedTokens);
      convertedTokensData.freeTokens = this.utils.convertKeysToInt(tokensData.freeTokens);
      convertedTokensData.totalActiveTokens = this.utils.convertKeysToInt(tokensData.totalActiveTokens);
  
        // console.log(`getResellerTokensStatus tokensData is ${JSON.stringify(convertedTokensData)}`);
        this.resellerTokensStatusData = convertedTokensData;
        this.presentAllocatedTokensPart = true;

        this.existingTotalAccountTypes = Array.from(Object.keys(convertedTokensData.totalActiveTokens).map(key => Number(key))).sort();
        this.existingFreeAccountTypes = Array.from(Object.keys(convertedTokensData.freeTokens).map(key => Number(key))).sort();
        this.existingAllocatedAccountTypes = Array.from(Object.keys(convertedTokensData.allocatedTokens).map(key => Number(key))).sort();

        console.log(`getResellerTokensStatus existingFreeAccountTypes is ${JSON.stringify(this.existingFreeAccountTypes)}`);
    });
  }

  groupByAccountType(tokens: AccessTokenData[]): { [key: number]: AccessTokenData[] } {
    return tokens.reduce((acc: { [key: number]: AccessTokenData[] }, token) => {
      const accountType = token.accountType;
      if (!acc[accountType]) {
        acc[accountType] = [];
      }
      acc[accountType].push(token);
      return acc;
    }, {});
  }

  getAccountTypes(): number[] {
    // console.log(`getAccountTypes length is ${this.existingAllocatedTokensToOrgList.length()} return ${JSON.stringify(this.existingAllocatedTokensToOrgList)}`);
    return Object.keys(this.existingAllocatedTokensToOrgList).map(Number);
  }

  allocateTokenToOrg(): void {
    if (!(this.orgTokenAllocationAmount > 0) || this.selectedAccountTypeForTokenAllocation == AccountTypeEnum.UNKNOWN){
      this.allocateTokenToOrgFailed = true;
      this.allocateTokensToOrgErrorMessage = this.translate.instant('adminActions.missingDetailsOnTokenAllocation');
      return;
    }

    this.res_allocatedTokensToGroupList = [];
    this.res_allocatedTokensBodiesToGroupList = [];
    this.allocateTokenToOrgFailed = false;
    this.allocateTokensToOrgErrorMessage = "";
    
    this.userDataService.allocateTokensToGroup(this.selectedOrgId, this.orgTokenAllocationAmount, this.selectedAccountTypeForTokenAllocation, this.selectedCareerProcessTypeForTokenAllocation).subscribe(allocatedTokens => {
      this.res_allocatedTokensToGroupList = allocatedTokens;
      this.res_allocatedTokensBodiesToGroupList = allocatedTokens.map(token => token.tokenBody);

      this.getUserCreatedOrgs();
      this.getResellerTokensStatus();
      this.getExistingActiveTokensForOrg();
    }, error => {
      if (error.status == 400){
          this.allocateTokensToOrgErrorMessage = this.translate.instant('adminActions.tokenAllocationFailed')
      }
      this.allocateTokenToOrgFailed = true;
  });
  }
  

  copyAllocatedTokensToClipboard(shouldCopyAsUrl: boolean, copyNewTokensOnly: boolean) : void{
    let tokensListStr : string = "";
    let tokenToCopyList: string[] = [];
    let baseURL = this.envConfig.get(EnvConfigKeys.resellerTokenLoginBaseUrl);
    
    if (copyNewTokensOnly){
      tokenToCopyList = this.res_allocatedTokensToGroupList.map(token => token.tokenBody);
      for (let currTokenStr of tokenToCopyList){
        if (shouldCopyAsUrl){
          tokensListStr += baseURL + currTokenStr + "\n";
        }
        else{
          tokensListStr += currTokenStr + "\n";
        }
      }
    }
    else{
      for (let accountType of this.getAccountTypes()){
        tokensListStr += "\n" + this.getAccountTypeDescription(accountType) + ":\n";
        for (let token of this.existingAllocatedTokensToOrgList[accountType]){
          if (shouldCopyAsUrl){
            tokensListStr += baseURL + token.tokenBody + "\n";
          }
          else{
            tokensListStr += token.tokenBody + "\n";
          }
        }
      }
      tokenToCopyList = Object.values(this.existingAllocatedTokensToOrgList).flat().map(token => token.tokenBody);
    }


    // remove last '\n' from the string
    tokensListStr = tokensListStr.substring(0, tokensListStr.length - 1)
    this.clipboard.copy(tokensListStr);
 
    let tooltipElement = copyNewTokensOnly ? this.tooltip_newTokens : this.tooltip_existingTokens;
       
    this.showTooltip(tooltipElement);
  }

  copyAllocatedTokensToClipboardB2C(copyNewTokensOnly: boolean): void {
    let tokensListStr: string = "";
    const baseURL = this.envConfig.get(EnvConfigKeys.resellerTokenLoginBaseUrlB2C);

    if (copyNewTokensOnly) {
      for (let token of this.res_allocatedTokensToGroupList) {
        tokensListStr += baseURL + token.tokenBody + "\n";
      }
    } else {
      for (let accountType of this.getAccountTypes()) {
        tokensListStr += "\n" + this.getAccountTypeDescription(accountType) + ":\n";
        for (let token of this.existingAllocatedTokensToOrgList[accountType]) {
          tokensListStr += baseURL + token.tokenBody + "\n";
        }
      }
    }

    tokensListStr = tokensListStr.substring(0, tokensListStr.length - 1);
    this.clipboard.copy(tokensListStr);

    let tooltipElement = copyNewTokensOnly ? this.tooltip_newTokens : this.tooltip_existingTokens;
    this.showTooltip(tooltipElement);
  }

  copyOrgIdToClipboard(): void {
    this.clipboard.copy(this.selectedOrgId);
    this.showTooltip(this.tooltip_orgId);
  }

  copyAllocatedTokensToClipboardB2U(copyNewTokensOnly: boolean): void {
    let tokensListStr: string = "";
    const baseURL = this.envConfig.get(EnvConfigKeys.resellerTokenLoginBaseUrlB2U);

    if (copyNewTokensOnly) {
      for (let token of this.res_allocatedTokensToGroupList) {
        tokensListStr += baseURL + token.tokenBody + "\n";
      }
    } else {
      for (let accountType of this.getAccountTypes()) {
        tokensListStr += "\n" + this.getAccountTypeDescription(accountType) + ":\n";
        for (let token of this.existingAllocatedTokensToOrgList[accountType]) {
          tokensListStr += baseURL + token.tokenBody + "\n";
        }
      }
    }

    tokensListStr = tokensListStr.substring(0, tokensListStr.length - 1);
    this.clipboard.copy(tokensListStr);

    let tooltipElement = copyNewTokensOnly ? this.tooltip_newTokens : this.tooltip_existingTokens;
    this.showTooltip(tooltipElement);
  }

  deleteOrg(): void{
    this.resellerOrgActionErrorMessage = "";
    this.personalUserDataServiceForBaseClass.deleteOrg(this.selectedOrgId).subscribe(res => {
      this.getUserCreatedOrgs();
    }, error => {
      this.isEditingOrg = false;
      this.resellerOrgActionErrorMessage = this.translate.instant("adminActions.deleteOrgFailed");
    });
  }

  editOrg(): void{

    let orgDetails = this.orgsData.find(org => org.id == this.selectedOrgId);
    this.userEditOrgName =  orgDetails ? orgDetails.name : "";
    this.userEditOrgDescription = orgDetails ? orgDetails.description : "";

    this.isEditingOrg = true;
    this.isCreatingOrg = false;
  }

  cancelOrgEdit(): void{
    this.isEditingOrg = false;
  }

  submitOrgEdit(orgId: string): void{
    this.resellerOrgActionErrorMessage = "";
    if (this.userEditOrgName == "" || this.userEditOrgDescription== ""){
      return;
    }

    this.personalUserDataServiceForBaseClass.editOrgDetails(orgId, this.userEditOrgName, this.userEditOrgDescription).subscribe(res => {
      this.isEditingOrg = false;
      this.getUserCreatedOrgs();
    }, error => {
      this.isEditingOrg = false;
      this.resellerOrgActionErrorMessage = this.translate.instant("adminActions.editOrgFailed");
    });
    
    // and if the org is the selected one, we need to update the name and description
  } 
  showTooltip(tooltipElement : MatTooltip):void {
    {
      tooltipElement.show();
  
      setTimeout(() => {
        tooltipElement.hide();
      }, 2000);
    }
  }

  getAccountTypeDescription(accountType: number): string {
    return AccountTypeDescriptions[accountType as AccountTypeEnum];
  }
} 